/*Mahesh S  : 18-10-2023 : BT-102838 -  Breeze - Net Position - Start*/
import moment from "moment";
import { ORDERS_GRID_REF } from "../../utils/global_functions";
import { EXCHANGE_NAME_LIVEPULSE, MKT_SEGMENTID_HAVING_LOTS, ORDER_ENTRY_BUY_SELL_TEXT, ORDER_PRODUCT_TYPES, SCRIP_INSTRUMENTS } from "../../utils/global_variables";
import { _getOrderDisplayStatus, _getOrderEntryAllExchangeWiseProductTypes } from "../orders";



function _getProductType(type, exchange, productTypeText, objLoginSession) {
    const objResp = _getOrderEntryAllExchangeWiseProductTypes(productTypeText, exchange, objLoginSession);
    if (objResp?.data?.length > 0) {
        if (exchange.includes('EQ') && type === ORDER_PRODUCT_TYPES.INTRADAY) {
            type = ORDER_PRODUCT_TYPES.MARGIN;
            const obj = objResp?.data?.find(obj => obj?.sDefaultProductType === type);
            return obj?.sDescription;
        } else if (!exchange.includes('EQ') && type === ORDER_PRODUCT_TYPES.DELIVERY) {
            type = ORDER_PRODUCT_TYPES.CARRYFORWARD;
            const obj = objResp?.data?.find(obj => obj?.sDefaultProductType === type);
            return obj?.sDescription;
        } else if (type === ORDER_PRODUCT_TYPES.BTST) {
            const obj = objResp?.data?.find((eachObj) => {
                return eachObj?.sDefaultProductType === ORDER_PRODUCT_TYPES.PTST;
            });
            return obj?.sDescription;
        }
        else {
            const obj = objResp?.data?.find(obj => obj?.sDefaultProductType === type);
            // Azeem K : 09-11-2023 :BT-101818 : Order Book - Single Scrip Order – Issue - product type getting blank – Start
            if (obj) {

                return obj?.sDescription;
            } else {
                return type;
            }
        }
    } else {
        return type;
    }
    // Azeem K : 09-11-2023 :BT-101818 : Order Book - Single Scrip Order – Issue - product type getting blank – End

}

/*Mahesh S  : 19-06-2023 : BT-102838 -  Breeze - Net Position - end*/

const _getQtyLotCaption = (MktSegId, LotSize, details) => {
    let _caption = 'Qty';
    try {
        if (MktSegId !== undefined && (MKT_SEGMENTID_HAVING_LOTS.indexOf(MktSegId) !== -1))
            _caption = details ? "Lot(1 Lot = " + LotSize + ")" : "Lot";
    }
    catch (e) {
        console.log(e);
    }
    return _caption;
};

const positionsFilter = (data, positionsData) => {
    let arrPositions = [];
    if (Object?.keys(data)?.length > 0) {
        if (data?.alphabetically === 'a-z') {
            arrPositions = positionsData?.slice().sort((a, b) => a?.title.localeCompare(b?.title));
        } else if (data?.alphabetically === 'z-a') {
            arrPositions = positionsData?.slice().sort((a, b) => b?.title.localeCompare(a?.title));
        } else if (data?.quantity === 'low_high') {
            arrPositions = positionsData?.slice().sort((a, b) => a?.net_quantity - b?.net_quantity);
        } else if (data?.quantity === 'high_low') {
            arrPositions = positionsData?.slice().sort((a, b) => b?.net_quantity - a?.net_quantity);
        } else if (data?.CMV === 'low_high') {
            arrPositions = positionsData?.slice().sort((a, b) => parseFloat(a.cmv) - parseFloat(b.cmv));
        } else if (data?.CMV === 'high_low') {
            arrPositions = positionsData?.slice().sort((a, b) => parseFloat(b.cmv) - parseFloat(a.cmv));
        } else if (data?.DaysPl === 'low_high') {
            arrPositions = positionsData?.slice().sort((a, b) => parseFloat(a?.todays_pl) - parseFloat(b?.todays_pl));
        } else if (data?.DaysPl === 'high_low') {
            arrPositions = positionsData?.slice().sort((a, b) => parseFloat(b?.todays_pl) - parseFloat(a?.todays_pl));
        }
        if (data?.position === 'open') {
            arrPositions = positionsData?.filter((obj) => parseFloat(obj?.net_quantity) !== 0);
        } else if (data?.position === 'close') {
            arrPositions = positionsData?.filter(obj => parseFloat(obj?.net_quantity) === 0);
        }
        if (data?.hasOwnProperty('Product_Type')) {
            arrPositions = positionsData?.filter(obj => obj?.product_type === data?.Product_Type);
        }
        if (data?.DaysPlMin && data?.DaysPlMax) {
            arrPositions = positionsData?.filter(x => parseFloat(x?.todays_pl) >= parseFloat(data?.DaysPlMin) && parseFloat(x?.todays_pl) <= parseFloat(data?.DaysPlMax));
        } else if (data?.DaysPlMax) {
            arrPositions = positionsData?.filter(x => parseFloat(x?.todays_pl) <= parseFloat(data?.DaysPlMax));
        } else if (data?.DaysPlMin) {
            arrPositions = positionsData?.filter(x => parseFloat(x?.todays_pl) >= parseFloat(data?.DaysPlMin));
        }
        if (data?.hasOwnProperty('segment')) {
            if (data?.segment === 'All' || data?.segment === 'All Combined') {
                arrPositions = positionsData;
            } else {
                arrPositions = positionsData?.filter(obj => obj?.customSegment === data?.segment);
            }
        }
    }
    if (arrPositions?.length > 0) {
        return arrPositions;
    } else {
        return [];
    }
};

const ordersFilters = (data, ordersData) => {
    let arrOrders = ordersData;
    if (Object?.keys(data)?.length > 0) {
        if (data?.alphabetically === 'a-z') {
            arrOrders = arrOrders?.slice()?.sort((a, b) => a?.symbol ? a?.symbol?.localeCompare(b?.symbol) : a?.spread_symbol?.localeCompare(b?.spread_symbol));
        } else if (data?.alphabetically === 'z-a') {
            arrOrders = arrOrders?.slice()?.sort((a, b) => b?.symbol ? b?.symbol.localeCompare(a?.symbol) : b?.spread_symbol.localeCompare(a?.spread_symbol));
        }
        if (data?.orderType === ORDER_ENTRY_BUY_SELL_TEXT.BUY) {
            arrOrders = arrOrders?.filter(obj => obj?.type === ORDER_ENTRY_BUY_SELL_TEXT.BUY || obj?.transaction_type === ORDER_ENTRY_BUY_SELL_TEXT.BUY);
        } else if (data?.orderType === ORDER_ENTRY_BUY_SELL_TEXT.SELL) {
            arrOrders = arrOrders?.filter(obj => obj?.type === ORDER_ENTRY_BUY_SELL_TEXT.SELL || obj?.transaction_type === ORDER_ENTRY_BUY_SELL_TEXT.SELL);
        }
        if (data?.hasOwnProperty('Product_Type')) {
            // use correct prod_type property to filter product types; all multileg orders by default have carryforward product type
            arrOrders = arrOrders?.filter(obj => obj?.prod_type === data?.Product_Type || obj?.exchangeWiseProductType === data?.Product_Type || obj?.product_type === data?.Product_Type);
        }
        if (data?.hasOwnProperty('Exchange_Type')) {
            // Data contains exchange as NSE_CURR and UI/filter contains value as NSECDS; so we need to use global variable that has all indices and their values that will be shown on UI
            arrOrders = arrOrders?.filter(obj => EXCHANGE_NAME_LIVEPULSE[obj?.exchange] === data?.Exchange_Type || obj?.exchangeName?.split('_')[0] === data?.Exchange_Type || obj?.exchange?.split('_')[0] === data?.Exchange_Type);
            // Vaibhav Singh: 20-02-24:Status check upadted: Start
        }
        if (data?.hasOwnProperty('order_status')) {
            arrOrders = arrOrders?.filter(obj => _getOrderDisplayStatus(obj?.status) === data?.order_status);
            // Vaibhav Singh: 20-02-24:Status check upadted: End
        }
        //BREEZE : 305 : Side tray Order Cart : ManasaB : 20-12-2024 : Adding cart name filter in orders - Start
        if (data?.hasOwnProperty('order_cart')) {
            arrOrders = arrOrders?.filter(obj => obj?.orderCartName === data?.order_cart);
        }
        //BREEZE : 305 : Side tray Order Cart : ManasaB : 20-12-2024 : Adding cart name filter in orders - End
        if (data?.DaysPlMin) {
            arrOrders = arrOrders?.filter(x => ((parseInt(x?.totalQuantity) * parseFloat(x?.price)) > parseFloat(data?.DaysPlMin)));
        }
        if (data?.DaysPlMax) {
            arrOrders = arrOrders?.filter(x => ((parseInt(x?.totalQuantity) * parseFloat(x?.price)) < parseFloat(data?.DaysPlMax)));
        }
    } else { }
    // if (arrOrders?.length > 0) {
    return arrOrders;
    // }else{}

};

const formatScripDesc = (expiryDate, instrument, opstionType, strikePrice) => {

    let sExpiryDate = ""; let sIntrument = ""; let sOptionType = ""; let sStrikePrice = "";
    if (expiryDate) {
        //Expiry date format DD MMM in net position tab and in square of all modal
        sExpiryDate = moment(expiryDate).format('DD MMM').toUpperCase() + ' ';
    } else {
        sExpiryDate = "";
    }

    if ((instrument === 'EQ') || (instrument === SCRIP_INSTRUMENTS.EQUITIES) || (instrument === SCRIP_INSTRUMENTS.OPTSTK) || (instrument === SCRIP_INSTRUMENTS.OPTCUR_TEXT)
        || (instrument === SCRIP_INSTRUMENTS.OPTIDX) || (instrument === SCRIP_INSTRUMENTS.OPTFUT) || (instrument === SCRIP_INSTRUMENTS.OPTCOM_TEXT)) {
        sIntrument = "";
    }
    else {
        sIntrument = instrument?.substr(0, 3) + " ";
    }



    if ((strikePrice === '-1') || (strikePrice === '0.00') || (strikePrice === '0.01')) {
        sStrikePrice = "";
    }
    else {
        sStrikePrice = strikePrice + " ";
    }

    if ((opstionType === 'XX')) {
        sOptionType = "";
    }
    else {
        sOptionType = opstionType;
    }

    return " " + sExpiryDate + sIntrument + sStrikePrice + sOptionType;

};


const _filterOptions = [
    'equals',
    'notEqual',
    'lessThan',
    'lessThanOrEqual',
    'greaterThan',
    'greaterThanOrEqual',
    'inRange',
    'blank',
    'notBlank'
];

const _getFilterDataForGrid = ({ filterOption, value, filterText }) => {
    if (filterText == null) {
        return false;
    } else {
        switch (filterOption) {
            case 'equals': {
                return parseFloat(filterText) === parseFloat(value);
            }
            case 'notEqual': {
                return parseFloat(filterText) !== parseFloat(value);
            }
            case 'lessThan': {
                return parseFloat(value) < parseFloat(filterText);
            }
            case 'lessThanOrEqual': {
                return parseFloat(value) <= parseFloat(filterText);
            }
            case 'greaterThan': {
                return parseFloat(value) > parseFloat(filterText);
            }
            case 'greaterThanOrEqual': {
                return parseFloat(value) >= parseFloat(filterText);
            }
            case 'inRange': {
                const agFilterModel = ORDERS_GRID_REF?.current?.api?.getFilterModel();
                if (Object?.keys(agFilterModel)?.length > 0) {
                    const fromValue = agFilterModel[Object?.keys(agFilterModel)[0]].filter;
                    const toValue = agFilterModel[Object?.keys(agFilterModel)[0]].filterTo;
                    return parseFloat(value) >= parseFloat(fromValue) && parseFloat(value) <= parseFloat(toValue);
                } else {
                    return false;
                }
            }
            case 'blank': {
                return false;
            }
            case 'notBlank': {
                return true;
            }
            default:
                return false;
        }
    }
};

export { _getProductType, _getQtyLotCaption, positionsFilter, ordersFilters, formatScripDesc, _filterOptions, _getFilterDataForGrid };

/*Mahesh S  : 18-10-2023 : BT-102838 -  Breeze - Net Position - End*/
